import { useState } from 'react';
import { Button, DatePicker, Field, Modal } from '@bcecloud/portal-ui';

export interface SnoozeDialogProps {
  readonly accountName: string;
  /** `yyyy-mm-dd`; the earliest day a snooze can end (tomorrow). */
  readonly min: string;
  readonly saving: boolean;
  readonly onSnooze: (until: string) => void;
  readonly onClose: () => void;
}

/** Picks the day a client comes back into To contact. */
export function SnoozeDialog({ accountName, min, saving, onSnooze, onClose }: SnoozeDialogProps): React.ReactElement {
  const [until, setUntil] = useState('');
  return (
    <Modal
      open
      title="Snooze"
      subtitle={accountName}
      onClose={() => {
        if (!saving) onClose();
      }}
      actions={
        <>
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button onClick={() => onSnooze(until)} disabled={until === '' || until < min || saving}>
            {saving ? 'Saving…' : 'Snooze'}
          </Button>
        </>
      }
    >
      <p className="mb-4 text-portal-small text-portal-muted">They leave To contact until this day, then come back.</p>
      <Field label="Snooze until" htmlFor="snooze-until" required>
        <DatePicker id="snooze-until" value={until} min={min} onChange={setUntil} />
      </Field>
    </Modal>
  );
}
